import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { AdminAPI } from '@shared/types/api';
import { api } from '@/lib/api';

export type PaymentOriginFilter = 'all' | 'STRIPE' | 'APP_STORE' | 'PLAY_STORE';
export type PaymentTimeframeOption = '7d' | '30d' | '90d' | '365d' | 'all';

interface UseAdminPaymentsParams {
  page?: number;
  limit?: number;
  status?: 'all' | 'succeeded' | 'pending' | 'failed' | 'refunded';
  origin?: PaymentOriginFilter;
  timeframe?: PaymentTimeframeOption;
  refetchInterval?: number | false;
}

export function useAdminPayments(params: UseAdminPaymentsParams = {}) {
  const { page = 1, limit = 25, status = 'all', origin = 'all', timeframe = 'all', refetchInterval } = params;

  return useQuery<AdminAPI.GetPaymentsResponse, Error>({
    queryKey: ['admin', 'payments', page, limit, status, origin, timeframe],
    refetchInterval,
    placeholderData: keepPreviousData,
    queryFn: async (): Promise<AdminAPI.GetPaymentsResponse> => {
      const searchParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        status,
      });
      if (origin !== 'all') searchParams.set('origin', origin);
      if (timeframe !== 'all') searchParams.set('timeframe', timeframe);
      return api.get(`/admin/payments?${searchParams.toString()}`);
    },
  });
}

